import { useState } from "react";
import { useProposalT } from "../i18n/ProposalI18nContext";

export function BeforeAfterSection() {
  const { t } = useProposalT();
  const [detailOpen, setDetailOpen] = useState(false);

  const traditionalCostGroups = [
    {
      category: t("beforeAfter.accordionCat1"),
      items: [
        {
          label: t("beforeAfter.accordionCat1.rent"),
          pct: "30-38%",
          barWidth: "36%",
        },
        {
          label: t("beforeAfter.accordionCat1.condo"),
          pct: "10-14%",
          barWidth: "13%",
        },
        {
          label: t("beforeAfter.accordionCat1.tax"),
          pct: "6-9%",
          barWidth: "8%",
        },
      ],
    },
    {
      category: t("beforeAfter.accordionCat2"),
      items: [
        {
          label: t("beforeAfter.accordionCat2.energy"),
          pct: "7-11%",
          barWidth: "10%",
        },
        {
          label: t("beforeAfter.accordionCat2.staff"),
          pct: "10-14%",
          barWidth: "13%",
        },
        {
          label: t("beforeAfter.accordionCat2.cleaning"),
          pct: "5-8%",
          barWidth: "7%",
        },
        {
          label: t("beforeAfter.accordionCat2.internet"),
          pct: "3-6%",
          barWidth: "5%",
        },
        {
          label: t("beforeAfter.accordionCat2.maintenance"),
          pct: "3-5%",
          barWidth: "4%",
        },
        {
          label: t("beforeAfter.accordionCat2.water"),
          pct: "1-2%",
          barWidth: "2%",
        },
      ],
    },
    {
      category: t("beforeAfter.accordionCat3"),
      items: [
        {
          label: t("beforeAfter.accordionCat3.furniture"),
          pct: "6-9%",
          barWidth: "8%",
        },
        {
          label: t("beforeAfter.accordionCat3.coffee"),
          pct: "2-4%",
          barWidth: "3%",
        },
        {
          label: t("beforeAfter.accordionCat3.insurance"),
          pct: "1-2%",
          barWidth: "2%",
        },
        {
          label: t("beforeAfter.accordionCat3.admin"),
          pct: "3-5%",
          barWidth: "4%",
        },
      ],
    },
  ];

  return (
    <>
      {/* ── De → Para ── */}
      <section
        className="py-16 px-6 font-space-grotesk"
        style={{ background: "#FDFBF7", borderTop: "1px solid #E8E6E3" }}
      >
        <div style={{ maxWidth: "56rem", margin: "0 auto" }}>
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <span
              style={{
                display: "inline-block",
                padding: "6px 16px",
                borderRadius: "999px",
                fontSize: "13px",
                fontWeight: 500,
                color: "#1A1814",
                border: "1px solid #E8E6E3",
                background: "white",
                marginBottom: "12px",
              }}
            >
              {t("beforeAfter.badge")}
            </span>
            <h2
              className="text-3xl font-bold mb-3"
              style={{ color: "#1A1814" }}
            >
              {t("beforeAfter.heading")}
            </h2>
            <p
              className="text-base"
              style={{ color: "#78736D", maxWidth: "540px", margin: "0 auto" }}
            >
              {t("beforeAfter.subheading")}
            </p>
          </div>

          {/* Grid: Tradicional | arrow | Com Woba */}
          <div className="grid grid-cols-1 md:grid-cols-[1fr_40px_1fr] gap-3 md:gap-0 items-stretch">
            {/* TRADICIONAL */}
            <div
              style={{
                background: "#FDFBF7",
                border: "1px solid #E8E6E3",
                borderRadius: "12px",
                padding: "16px 18px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "14px",
                }}
              >
                <span
                  className="text-sm font-bold uppercase tracking-wider"
                  style={{ color: "#78736D" }}
                >
                  {t("beforeAfter.traditional")}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {[
                  {
                    value: t("beforeAfter.trad.suppliers"),
                    sub: t("beforeAfter.trad.suppliersDesc"),
                    suffix: null,
                  },
                  {
                    value: t("beforeAfter.trad.timeline"),
                    sub: t("beforeAfter.trad.timelineDesc"),
                    suffix: t("beforeAfter.trad.timelineSuffix"),
                  },
                  {
                    value: t("beforeAfter.trad.variableCosts"),
                    sub: t("beforeAfter.trad.variableCostsDesc"),
                    suffix: null,
                  },
                  {
                    value: t("beforeAfter.trad.closedContract"),
                    sub: t("beforeAfter.trad.closedContractDesc"),
                    suffix: null,
                  },
                  {
                    value: t("beforeAfter.trad.noVisibility"),
                    sub: t("beforeAfter.trad.noVisibilityDesc"),
                    suffix: null,
                  },
                  {
                    value: t("beforeAfter.trad.blindDecision"),
                    sub: t("beforeAfter.trad.blindDecisionDesc"),
                    suffix: null,
                  },
                ].map((row, i) => (
                  <div key={i}>
                    {i > 0 && (
                      <div
                        style={{
                          height: "1px",
                          background: "#E8E6E3",
                          marginBottom: "12px",
                        }}
                      />
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M4 8h8M4 4.5l3.5 3.5L4 11.5M12 4.5L8.5 8l3.5 3.5"
                          stroke="#78736D"
                          strokeWidth="1.3"
                          strokeLinecap="round"
                        />
                      </svg>
                      <span
                        className={
                          row.suffix || row.value.length > 3
                            ? "text-lg font-bold"
                            : "text-2xl font-extrabold"
                        }
                        style={{ color: "#1A1814", lineHeight: 1 }}
                      >
                        {row.value}
                      </span>
                      {row.suffix && (
                        <span
                          className="text-base font-bold"
                          style={{ color: "#78736D", marginLeft: "4px" }}
                        >
                          {row.suffix}
                        </span>
                      )}
                    </div>
                    <p
                      className="text-sm"
                      style={{ color: "#78736D", margin: "4px 0 0" }}
                    >
                      {row.sub}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Arrow — right on desktop, down on mobile */}
            <div className="flex items-center justify-center">
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "#FFF8E1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  className="hidden md:block"
                >
                  <path
                    d="M4 9h10M11 5.5L14.5 9 11 12.5"
                    stroke="#B8860B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  className="md:hidden"
                >
                  <path
                    d="M9 4v10M5.5 11L9 14.5 12.5 11"
                    stroke="#B8860B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>

            {/* COM WOBA */}
            <div
              style={{
                background: "#1A1814",
                border: "1px solid #333",
                borderLeft: "3px solid #FFD900",
                borderRadius: "12px",
                padding: "16px 18px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "14px",
                }}
              >
                <span
                  className="text-sm font-bold uppercase tracking-wider"
                  style={{ color: "#FFD900" }}
                >
                  {t("beforeAfter.withWoba")}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {[
                  {
                    value: t("beforeAfter.woba.singleContract"),
                    sub: t("beforeAfter.woba.singleContractDesc"),
                    suffix: null,
                    highlight: false,
                    icon: "check",
                  },
                  {
                    value: t("beforeAfter.woba.timeline"),
                    sub: t("beforeAfter.woba.timelineDesc"),
                    suffix: t("beforeAfter.woba.timelineSuffix"),
                    highlight: false,
                    icon: "check",
                  },
                  {
                    value: t("beforeAfter.woba.fixedValue"),
                    sub: t("beforeAfter.woba.fixedValueDesc"),
                    suffix: null,
                    highlight: false,
                    icon: "check",
                  },
                  {
                    value: t("beforeAfter.woba.onDemand"),
                    sub: t("beforeAfter.woba.onDemandDesc"),
                    suffix: null,
                    highlight: false,
                    icon: "check",
                  },
                  {
                    value: t("beforeAfter.woba.dashboard"),
                    sub: t("beforeAfter.woba.dashboardDesc"),
                    suffix: null,
                    highlight: false,
                    icon: "check",
                  },
                  {
                    value: t("beforeAfter.woba.ai"),
                    sub: t("beforeAfter.woba.aiDesc"),
                    suffix: null,
                    highlight: false,
                    icon: "check",
                  },
                  {
                    value: t("beforeAfter.woba.bestPrice"),
                    sub: t("beforeAfter.woba.bestPriceDesc"),
                    suffix: null,
                    highlight: true,
                    icon: "shield",
                  },
                ].map((row, i) => (
                  <div key={i}>
                    {i > 0 && (
                      <div
                        style={{
                          height: "1px",
                          background: "rgba(255,255,255,0.1)",
                          marginBottom: "12px",
                        }}
                      />
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {row.icon === "shield" ? (
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#FFD900"
                          strokeWidth="2"
                        >
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        </svg>
                      ) : (
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M3.5 8.5l3 3 6-6"
                            stroke="#22C55E"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                      <span
                        className={
                          row.suffix || row.value.length > 3
                            ? "text-lg font-bold"
                            : "text-2xl font-extrabold"
                        }
                        style={{
                          color: row.highlight ? "#FFD900" : "#FFFFFF",
                          lineHeight: 1,
                        }}
                      >
                        {row.value}
                      </span>
                      {row.suffix && (
                        <span
                          className="text-base font-bold"
                          style={{
                            color: "rgba(255,255,255,0.5)",
                            marginLeft: "4px",
                          }}
                        >
                          {row.suffix}
                        </span>
                      )}
                    </div>
                    <p
                      className="text-sm"
                      style={{
                        color: "rgba(255,255,255,0.6)",
                        margin: "4px 0 0",
                      }}
                    >
                      {row.sub}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Accordion — detalhamento dos 13 custos */}
          <div
            style={{
              marginTop: "32px",
              border: "1px solid #E8E6E3",
              borderRadius: "12px",
              background: "white",
              overflow: "hidden",
            }}
          >
            <button
              onClick={() => setDetailOpen((v) => !v)}
              className="flex items-center justify-between w-full px-5 py-4 text-sm font-bold transition-all hover:bg-[#FDFBF7]"
              style={{
                background: "white",
                color: "#1A1814",
                border: "none",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M3 14l4-4 3 3 7-7"
                    stroke="#B8860B"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>{t("beforeAfter.accordionLabel")}</span>
              </div>
              <svg
                width="18"
                height="18"
                viewBox="0 0 20 20"
                fill="none"
                style={{
                  flexShrink: 0,
                  transition: "transform .2s ease",
                  transform: detailOpen ? "rotate(180deg)" : "rotate(0deg)",
                }}
              >
                <path
                  d="M6 8l4 4 4-4"
                  stroke="#78736D"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {detailOpen && (
              <div style={{ padding: "0 28px 28px" }}>
                <div
                  style={{
                    height: "1px",
                    background: "#E8E6E3",
                    margin: "0 0 18px",
                  }}
                />
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#1A1814",
                    margin: "0 0 16px",
                  }}
                >
                  {t("beforeAfter.accordionIntro")}
                </p>
                {traditionalCostGroups.map((group) => (
                  <div key={group.category}>
                    <p
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "#9E9A94",
                        margin: "0 0 10px",
                      }}
                    >
                      {group.category}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                        marginBottom: "18px",
                      }}
                    >
                      {group.items.map((item) => (
                        <div key={item.label}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span
                              style={{ fontSize: "12px", color: "#78736D" }}
                            >
                              {item.label}
                            </span>
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#9E9A94",
                              }}
                            >
                              {item.pct}
                            </span>
                          </div>
                          <div
                            style={{
                              height: "6px",
                              borderRadius: "999px",
                              background: "#F5F3EF",
                            }}
                          >
                            <div
                              style={{
                                width: item.barWidth,
                                height: "100%",
                                borderRadius: "999px",
                                background: "#FFD900",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
                <div
                  style={{
                    borderRadius: "10px",
                    padding: "14px",
                    background: "#F5F3EF",
                    border: "1px solid #E8E6E3",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      color: "#78736D",
                      margin: 0,
                    }}
                  >
                    <strong>{t("beforeAfter.accordionSummaryBold1")}</strong>{" "}
                    {t("beforeAfter.accordionSummaryMiddle")}{" "}
                    <strong>{t("beforeAfter.accordionSummaryBold2")}</strong>
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
